import { render } from "./SettingsContactGroupsView.vue?vue&type=template&id=f27f9466"
import script from "./SettingsContactGroupsView.vue?vue&type=script&lang=js"
export * from "./SettingsContactGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__